import Cookies from 'js-cookie'
import { RouterProvider } from 'react-router'

import { Error } from './common/components/Error'
import { NotFound } from './common/components/NotFound'
import { COOKIES_KEYS } from './common/constants/cookiesKeys'
import { AuthenticatedLayout } from './common/layouts/AuthenticatedLayout'
import UnauthenticatedLayout from './common/layouts/UnauthenticatedLayout'
import { SentryRoutes } from './lib/sentry'
import { LoginRoutes } from './modules/login/index.routes'
import { PanelRoutes } from './modules/panel/index.routes'
import { ProfileRoutes } from './modules/profile/index.routes'
import { RegistersRoutes } from './modules/registers/index.routes'
import { SettingsRoutes } from './modules/settings/index.routes'
import { SsoRoutes } from './modules/sso/index.routes'

export function AppRoutes() {
  const TOKEN = Cookies.get(COOKIES_KEYS.token)

  const router = SentryRoutes([
    {
      element: TOKEN ? <AuthenticatedLayout /> : <UnauthenticatedLayout />,
      errorElement: <Error />,
      children: [
        {
          path: '*',
          element: <NotFound authenticated={!!TOKEN} />,
        },
      ],
    },
    {
      errorElement: <Error />,
      children: [
        ...LoginRoutes,
        ...PanelRoutes,
        ...ProfileRoutes,
        ...SettingsRoutes,
        ...RegistersRoutes,
        ...SsoRoutes,
      ],
    },
  ])

  return <RouterProvider router={router} />
}
